import { createSlice } from "@reduxjs/toolkit";

export const recipientLists = createSlice({
  name: "recipientLists",
  initialState: {
    value: {
      status: false,
      data: [] as string[],
    },
  },
  reducers: {
    update_recipientLists: (state, action) => {
      state.value.status = true;
      state.value.data = action?.payload;
    },
    add_recipient: (state, action) => {
      state.value.data = [...state.value.data, action?.payload];
    },
    remove_recipient: (state, action) => {
      const { id } = action?.payload;
      const currentArray = [...state.value.data];
      const currentIndex = currentArray.findIndex((v: string) => v === id);
      currentArray.splice(currentIndex, 1);
      state.value.data = currentArray;
    },
    replace_recipient: (state, action) => {
      const { id } = action?.payload;
      const currentArray = state.value.data;
      const currentIndex = currentArray.findIndex((v: string) => v === id);
      currentArray.splice(currentIndex, 1, action?.payload);
      state.value.data = currentArray;
    },
    clear_recipientLists: (state) => {
      state.value.status = false;
      state.value.data = [];
    },
  },
});

export const {
  update_recipientLists,
  add_recipient,
  remove_recipient,
  replace_recipient,
  clear_recipientLists,
} = recipientLists.actions;

export default recipientLists.reducer;
